<template>
  <div
    class="absolute top-1/2 z-10 !flex -translate-y-1/2 !items-center !justify-center !bg-lightGray !shadow-md before:!content-none hover:!bg-white sm:!shadow-lg"
    :class="{
      '!border-l-0': side === 'left' && !small,
      '!border-r-0': side === 'right' && !small,
      '!left-0': side === 'left',
      '!right-0': side === 'right',
      '!h-20 !w-10 !border !border-solid !border-black-40 !p-2 lg:!h-28 lg:!w-14':
        !small,
      '!h-7 !w-7 !p-1': small,
      collapse: areAllSlidesVisible,
    }"
    @click="() => (side === 'left' ? swiper.slidePrev() : swiper.slideNext())"
  >
    <IconArrowLeft
      class="text-black"
      :class="side !== 'left' && 'rotate-180'"
    />
  </div>
</template>

<script setup lang="ts">
defineProps({
  side: {
    type: String as PropType<'left' | 'right'>,
    required: true,
    validator: (val: string) => ['left', 'right'].includes(val),
  },
  small: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
})
const swiper = useSwiper()
const areAllSlidesVisible = computed(
  () => swiper.value.isBeginning && swiper.value.isEnd,
)
</script>
